import React, { useState, useEffect } from 'react'
//import Sidebar from './component/Sidebar';
import Login from "./pages/Login";
import Investors from "./pages/Investors";
import Dashboard from "./pages/Dashboard";
import InvestDetails from "./pages/InvestDetails";
import WaitingList from "./pages/WaitingList";
// import WaitingList1 from "./pages/WaitingList1";
import InvestmentList from "./pages/InvestmentList";
import Leads from "./pages/Leads";
import Leads1 from "./pages/Leads1";
import PrivateRoute from './pages/PrivateRoute';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import '../node_modules/font-awesome/css/font-awesome.min.css'; 

import "./css/style.css";
import LoadingBar from 'react-top-loading-bar';

import AutoLogout from './pages/AutoLogout';
import ChangePassword from "./pages/ChangePassword";
import CountryAssignment from "./pages/CountryAssignment";
import LeadModal from "./pages/LeadModal";
import UserLogs from "./pages/UserLogs";
import CrowdLeads from "./pages/CrowdLeads";
import CrowdLeads_NonAcc from "./pages/CrowdLeads_NonAcc";


//import $ from "jquery";


const App = () => {
    const [progress, setProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    //console.log(window.location.pathname);

    useEffect(() => {
        simulateDataLoad();
      }, [])

      const simulateDataLoad = () => {
        setProgress(30);
    
        // Simulating data loading
        setTimeout(() => {
          setProgress(70);
    
          setTimeout(() => {
            setProgress(100);
            setIsLoading(false);
          }, 1000);
        }, 2000);
      };

    

    return(
        <>
         <div> <LoadingBar color="#FCB633" progress={isLoading ? progress : 100} onLoaderFinished={() => setProgress(0)} /> </div>
        <Router basename='/'> 
        <AutoLogout>
            <Routes> 
              <Route path="/" element={<Login />} />
              <Route path="/Investors" element={<PrivateRoute><Investors /></PrivateRoute>} />                
              <Route path="/Dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />     
              <Route path="/InvestDetails" element={<PrivateRoute><InvestDetails /></PrivateRoute>} />         
              <Route path="/WaitingList" element={<PrivateRoute><WaitingList /></PrivateRoute>} />    
              <Route path="/InvestmentList" element={<PrivateRoute><InvestmentList /></PrivateRoute>} />    
              <Route path="/Leads" element={<PrivateRoute><Leads /></PrivateRoute>} />
              <Route path="/Leads1" element={<PrivateRoute><Leads1 /></PrivateRoute>} />
              <Route path="/ChangePassword" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
              <Route path="/CountryAssignment" element={<PrivateRoute><CountryAssignment /></PrivateRoute>} />
              <Route path="/LeadModal" element={<PrivateRoute><LeadModal /></PrivateRoute>} />
              <Route path="/UserLogs" element={<PrivateRoute><UserLogs /></PrivateRoute>} />
              <Route path="/CrowdLeads" element={<PrivateRoute><CrowdLeads /></PrivateRoute>} />
                 <Route path="/CrowdLeads_NonAcc" element={<PrivateRoute><CrowdLeads_NonAcc /></PrivateRoute>} />
              
              
                
            </Routes>        
            </AutoLogout>
        </Router>     
        </>     
    );
};

export default App;


